import React, { Component } from 'react'

import { SimpleFormNoInit } from 'components/form'
import { TextInput, DatetimeInput, SelectInput, FileInput } from 'components/input'
import { change as changeAction } from 'redux-form'
import { connect } from 'react-redux'

import {
  InputOptions,
} from 'util/constants'

import { maxLength } from 'components/form'

import * as urls from './urls'
import * as utils from './utils'
import { Edit } from "components/detail";
import { FileField, ImageField } from "components/field";
import DisabledInput from "components/input/DisabledInput";


class NotificationEditBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();

    formDataRecord.append('message_type', record['message_type']);
    formDataRecord.append('title', record['title']);
    formDataRecord.append('body', record['body']);
    formDataRecord.append('app_type', record['app_type']);
    if(!!record['url'])
      formDataRecord.append('url', record['url']);
    formDataRecord.append('send_type', record['send_type']);
    if (record['shop_ids_file_data']) {
      formDataRecord.append('shop_ids_file_data', record['shop_ids_file_data']);
    }
    formDataRecord.append('status', record['status']);
    formDataRecord.append('delivery_type', record['delivery_type']);
    if (record['delivery_time']) {
      formDataRecord.append('delivery_time', record['delivery_time']);
    }
    props.crudUpdate(props.resource, props.id, formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    const { submitFailed, syncErrors, formValues, formInitial } = this.props;
    if (formInitial.status === utils.NOTIFICATION_STATUS_SUCCESS) {
      this.props.history.goBack();
    }

    const isRetry = formInitial.status === utils.NOTIFICATION_STATUS_FAILED;
    return (
      <Edit 
        editBackendPath={urls.notificationEditBackendPath}
        detailBackendPath={urls.notificationDetailBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleFormNoInit
          hideSaveButton={isRetry}
        >
          <DisabledInput
            source='message_type'
            label='Notification type'
            choices={utils.MESSAGE_TYPE_CHOICES}
          />
          { formValues.image && (
            <ImageField 
              source="image"
              title="title"
            />
          )}
          { isRetry 
            ? <DisabledInput 
                source='title'
                label='Title'
              />
            : <TextInput 
                source='title' 
                label='Title' 
                validators={[maxLength(128)]} 
                isRequired={true}
                options={InputOptions}
              />
          }
          { isRetry 
            ? <DisabledInput 
                source='body'
                label='Body'
              />
            : <TextInput 
                source='body'
                label='Body'
                isRequired={true}
                options={InputOptions}
              />
          }
          { isRetry
            ? <DisabledInput
              source='app_type'
              label='Target App'
            />
            : <SelectInput
              source='app_type'
              label='Target App'
              isRequired={true}
              choices={utils.APP_TYPE_CHOICES}
              defaultValue={utils.APP_TYPE_OCHA_MANAGER}
            />
          }
          { isRetry 
            ? <DisabledInput 
                source='url'
                label='URL / In App page'
              />
            : <TextInput 
                source='url'
                label='URL / In App page'
                isRequired={false}
                options={InputOptions}
              />
          }
          { isRetry 
            ? <DisabledInput 
                source='send_type'
                label='Target Users'
              />
            : <SelectInput 
                source='send_type'
                label='Target Users'
                isRequired={true}
                choices={utils.SEND_TYPE_CHOICES}
                defaultValue={utils.MESSAGE_SEND_ALL}
              />
          }
          { (formValues.send_type === utils.MESSAGE_SEND_SPECIFIC_USERS && formValues.shop_ids_file_path) && (
            <a 
              style={{marginTop: '15px'}} 
              href={formValues.shop_ids_file_path}
            >
              Download file
            </a>
          )}
          { (!isRetry && formValues.send_type === utils.MESSAGE_SEND_SPECIFIC_USERS) && (
            <FileInput source="shop_ids_file_data" label="Shop ids file">
              <FileField source="src" title="title" />
            </FileInput>
          )}
          { (submitFailed && syncErrors.shop_ids_file_data) && (
            <div 
              style={{
                position: 'relative',
                bottom: '15px',
                color: 'rgb(244, 67, 54)',
                fontSize: '12px',
                lineHeight: '12px',
                transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
              }}
            >
              <p>{syncErrors.shop_ids_file_data}</p>
            </div>
          )}

          <SelectInput
            source='delivery_type'
            label='Deliver Type'
            isRequired={true}
            disabled={isRetry}
            choices={utils.NOTIFICATION_DELIVER_TYPE_CHOICES}
            defaultValue={utils.NOTIFICATION_DELIVER_NOW}
            options={InputOptions}
          />

          { (formValues.delivery_type === utils.NOTIFICATION_DELIVER_LATER) && (
              isRetry 
              ? <DisabledInput 
                  source='delivery_time'
                  label='Delivery Time'
                />
              : <DatetimeInput
                  source='delivery_time'
                  label='Delivery Time'
                  isRequired={true}
                  options={InputOptions}
                  optionsTime={InputOptions}
                />
          )}
          { (
            !formInitial.status
            || formInitial.status === utils.NOTIFICATION_STATUS_DISABLED
            || formInitial.status === utils.NOTIFICATION_STATUS_PENDING
            ) && (
            isRetry 
            ? <DisabledInput 
                source='status'
                label='Status'
              />
            : 
              <SelectInput
                source='status'
                label='Status'
                isRequired={true}
                choices={utils.NOTIFICATION_STATUS_EDIT_CHOICES}
                options={InputOptions}
              />
          )}
          { isRetry && (
            <DisabledInput 
              source="status_display"
              label="Status"
            />
          )}
        </SimpleFormNoInit>
      </Edit>
    )
  }
}

export const NotificationEdit = connect(
  (state) => {
    return {
      submitFailed: (state.form['record-form'] || {}).submitFailed,
      syncErrors: ((state.form['record-form'] || {}).syncErrors || {}),
      formValues: ((state.form['record-form'] || {}).values || {}),
      formInitial: ((state.form['record-form'] || {}).initial || {}),
    }
  },
  {
    change: changeAction,
  }
)(NotificationEditBase);



// WEBPACK FOOTER //
// ./src/routes/notification/NotificationEdit.js